import type * as React from 'react';
import { useEffect } from 'react';

// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import { Loader } from '@crehana/ui';
import { useMe } from '@crehana/web/ReactContexts/AuthContext';

import Error404 from '@/views/Error404';

// biome-ignore lint/complexity/noBannedTypes: legacy code - complexity/noBannedTypes
function withAuth<TProps = {}>(
  Comp: React.ComponentType<React.PropsWithChildren<TProps>>,
) {
  // TODO: talk with the code owner to fix this code so we can enable this rule again
  // eslint-disable-next-line react/display-name
  return (props: TProps) => {
    const { loading, error, me } = useMe();

    useEffect(() => {
      if (!loading && !me) {
        window.location.href = '/entrar/';
      }
    }, [loading, me]);

    if (loading) {
      return (
        <div className="flex items-center justify-center w-full min-h-screen bg-base-lighter-8">
          <Loader />
        </div>
      );
    }

    if (error) {
      return <Error404 />;
    }

    // @ts-expect-error
    return <Comp {...props} />;
  };
}

export default withAuth;
